/* VINOD product page behaviour: gallery (thumbs + swipe), quantity, live offer ladder,
   countdown, tabs, sticky add-to-cart, bulk-enquiry modal, key-features See more, cart toast.

   All numbers come from data attributes the section renders (real prices in paise and
   the merchant's slab settings) — no figures are hardcoded here. */
(function () {
  var root = document.querySelector('[data-vd-pdp]');
  if (!root) return;

  var cfg = JSON.parse(root.getAttribute('data-vd-pdp') || '{}');
  var fmt = function (paise) {
    return '\u20b9' + Math.round(paise / 100).toLocaleString('en-IN', { maximumFractionDigits: 0 });
  };
  var shopRoot = function () {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  };

  /* ── gallery: on desktop the whole rail column (arrows included) is exactly as tall as the
     image stage, trimmed to whole thumbs so none is half-cut, and pages with the up/down
     arrows when there are more photos than fit. The stage pre-renders one panel per media
     item (image / native video / external video). ── */
  var stage = root.querySelector('[data-vd-stage]');
  var rail = root.querySelector('[data-vd-rail]');
  var up = root.querySelector('[data-vd-rail-step="-1"]');
  var down = root.querySelector('[data-vd-rail-step="1"]');
  var GAP = 10;

  function sizeRail() {
    if (!rail || !stage) return;
    if (window.matchMedia('(max-width: 768px)').matches) {
      rail.style.maxHeight = '';
      if (up) up.hidden = true;
      if (down) down.hidden = true;
      return;
    }
    var stageH = stage.getBoundingClientRect().height;
    var first = rail.firstElementChild;
    if (!stageH || !first) return;

    var slot = first.getBoundingClientRect().height + GAP;
    var count = rail.children.length;
    var fullH = count * slot - GAP;
    var needsArrows = fullH > stageH + 2;

    if (up) up.hidden = !needsArrows;
    if (down) down.hidden = !needsArrows;

    // arrows sit inside the same column, so subtract their boxes from the space left
    var arrowsH = 0;
    if (needsArrows) {
      var a = up && up.getBoundingClientRect().height ? up.getBoundingClientRect().height : 26;
      arrowsH = (a + 8) * 2;
    }
    var avail = stageH - arrowsH;
    var fits = Math.max(1, Math.floor((avail + GAP) / slot));
    rail.style.maxHeight = fits * slot - GAP + 'px';
    paintRailArrows();
  }

  function paintRailArrows() {
    if (!rail) return;
    if (up) up.disabled = rail.scrollTop <= 2;
    if (down) down.disabled = rail.scrollTop + rail.clientHeight >= rail.scrollHeight - 2;
    [up, down].forEach(function (b) { if (b) b.style.opacity = b.disabled ? 0.4 : 1; });
  }

  if (rail) {
    rail.style.overflowY = 'auto';
    rail.addEventListener('scroll', paintRailArrows);
    [up, down].forEach(function (b) {
      if (!b) return;
      b.addEventListener('click', function () {
        var dir = parseInt(b.getAttribute('data-vd-rail-step'), 10);
        rail.scrollBy({ top: dir * (rail.clientHeight - 20), behavior: 'smooth' });
      });
    });
    if (stage && window.ResizeObserver) new ResizeObserver(sizeRail).observe(stage);
    window.addEventListener('resize', sizeRail);
    setTimeout(sizeRail, 300);
  }

  function stopMedia(panel) {
    var vid = panel.querySelector('video');
    if (vid) { try { vid.pause(); } catch (e) {} }
    var ifr = panel.querySelector('iframe');
    if (ifr) { ifr.src = ifr.src; }
  }

  var thumbsArr = Array.prototype.slice.call(root.querySelectorAll('[data-vd-thumb]'));
  var panels = stage ? Array.prototype.slice.call(stage.querySelectorAll('[data-vd-media]')) : [];
  /* every gallery image loads eagerly — lazy loading is what made a swiped-to image flash
     white for a moment before appearing */
  if (stage) stage.querySelectorAll('img').forEach(function (im) { im.loading = 'eager'; });

  function show(i) {
    var t = thumbsArr[i];
    if (!t) return;
    var idx = t.getAttribute('data-vd-media-index');
    thumbsArr.forEach(function (o, j) { o.setAttribute('aria-current', j === i ? 'true' : 'false'); });
    panels.forEach(function (p) {
      var on = p.getAttribute('data-vd-media') === idx;
      if (!on) stopMedia(p);
      p.hidden = !on;
    });
    if (rail && window.matchMedia('(max-width: 768px)').matches) {
      rail.scrollTo({ left: Math.max(0, t.offsetLeft - 20), behavior: 'smooth' });
    }
  }

  thumbsArr.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });

  /* mobile: swipe the image left/right to page through the gallery */
  if (stage && thumbsArr.length > 1) {
    var x0 = 0, y0 = 0, t0 = 0;
    stage.addEventListener('touchstart', function (e) {
      var t = e.changedTouches[0];
      x0 = t.clientX; y0 = t.clientY; t0 = Date.now();
    }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      var t = e.changedTouches[0];
      var dx = t.clientX - x0, dy = t.clientY - y0;
      if (Date.now() - t0 > 800) return;
      if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy) * 1.4) return;
      var cur = 0;
      thumbsArr.forEach(function (th, i) { if (th.getAttribute('aria-current') === 'true') cur = i; });
      var n = dx < 0 ? cur + 1 : cur - 1;
      if (n < 0) n = thumbsArr.length - 1;
      if (n >= thumbsArr.length) n = 0;
      show(n);
    }, { passive: true });
  }

  /* ── quantity + the ladder that depends on it ── */
  var qtyOut = root.querySelector('[data-vd-qty]');
  var qty = 1;

  function slabPct(total) {
    var pct = 0;
    (cfg.slabs || []).forEach(function (s) {
      if (s.min && total >= s.min * 100 && s.pct > pct) pct = s.pct;
    });
    return pct;
  }
  function nextSlab(total) {
    var next = null;
    (cfg.slabs || []).forEach(function (s) {
      if (s.min && total < s.min * 100 && (!next || s.min < next.min)) next = s;
    });
    return next;
  }

  function paint() {
    if (qtyOut) qtyOut.textContent = qty;
    root.querySelectorAll('[data-vd-qty-input]').forEach(function (i) { i.value = qty; });

    var price = cfg.price || 0;
    var mrp = cfg.mrp || 0;
    var line = price * qty;
    var pct = slabPct(line);
    var off = Math.round((price * pct) / 100);
    var afterSlab = price - off;
    var prepaid = Math.round((afterSlab * (cfg.prepaidPct || 0)) / 100);
    var pay = afterSlab - prepaid;
    var next = nextSlab(line);

    var l1 = root.querySelector('[data-vd-ladder-1]');
    var l2 = root.querySelector('[data-vd-ladder-2]');
    var payEl = root.querySelector('[data-vd-pay]');
    var saveEl = root.querySelector('[data-vd-totalsave]');
    var nudge = root.querySelector('[data-vd-nudge]');

    if (l1) {
      l1.textContent = pct
        ? 'Extra ' + pct + '% OFF (' + fmt(off) + ') instantly. Grab it for just ' + fmt(afterSlab) + '!'
        : next
          ? 'Add ' + fmt(next.min * 100 - line) + ' more to unlock an extra ' + next.pct + '% OFF instantly.'
          : '';
    }
    if (l2) l2.textContent = 'Additional ' + (cfg.prepaidPct || 0) + '% OFF (' + fmt(prepaid) + ') on prepaid payments!';
    if (payEl) payEl.textContent = fmt(pay);
    if (saveEl) saveEl.textContent = mrp > pay ? 'Total saving ' + fmt(mrp - pay) : '';
    if (nudge) {
      nudge.textContent = next
        ? "You're only " + fmt(next.min * 100 - line) + ' away from the ' + next.pct + '% sale slab.'
        : 'Your cart qualifies for the top sale slab.';
    }

    root.querySelectorAll('[data-vd-summary]').forEach(function (el) { el.textContent = fmt(line); });
  }

  root.querySelectorAll('[data-vd-step]').forEach(function (b) {
    b.addEventListener('click', function () {
      qty = Math.max(1, Math.min(cfg.max || 99, qty + parseInt(b.getAttribute('data-vd-step'), 10)));
      paint();
    });
  });
  paint();

  /* ── countdown ── */
  var cd = root.querySelector('[data-vd-countdown]');
  if (cd && cfg.saleEnds) {
    var end = new Date(cfg.saleEnds).getTime();
    var cells = cd.querySelectorAll('b');
    var pad = function (n) { return String(n).padStart(2, '0'); };
    var tick = function () {
      var ms = end - Date.now();
      if (isNaN(end) || ms <= 0) { cd.hidden = true; return; }
      var parts = [
        Math.floor(ms / 86400000),
        Math.floor(ms / 3600000) % 24,
        Math.floor(ms / 60000) % 60,
        Math.floor(ms / 1000) % 60
      ];
      cells.forEach(function (c, i) { c.textContent = pad(parts[i]); });
    };
    tick();
    setInterval(tick, 1000);
  }

  /* ── tabs ── */
  var tabs = root.querySelectorAll('[data-vd-tab]');
  tabs.forEach(function (t) {
    t.addEventListener('click', function () {
      var id = t.getAttribute('data-vd-tab');
      tabs.forEach(function (o) { o.setAttribute('aria-selected', o === t ? 'true' : 'false'); });
      root.querySelectorAll('[data-vd-panel]').forEach(function (p) {
        p.hidden = p.getAttribute('data-vd-panel') !== id;
      });
    });
  });

  /* ── sticky add to cart ── */
  var sticky = root.querySelector('[data-vd-sticky]');
  var anchor = root.querySelector('[data-vd-buyrow]');
  if (sticky && anchor) {
    /* An IntersectionObserver also fired at the top of the page, where the buy row is simply
       still BELOW the fold — so the bar covered the image and thumbnails on load. Use a
       scroll test against a real anchor instead. */
    var galcol = root.querySelector('.vd-pdp__galcol');
    var syncSticky = function () {
      /* mobile: reveal once the thumbnail strip has scrolled off the top, so the bar can
         never cover the image or thumbs. desktop keeps the buy row as its trigger. */
      var mobile = window.matchMedia('(max-width: 768px)').matches;
      var el = mobile && galcol ? galcol : anchor;
      sticky.classList.toggle('is-on', el.getBoundingClientRect().bottom < 80);
    };
    window.addEventListener('scroll', syncSticky, { passive: true });
    window.addEventListener('resize', syncSticky);
    syncSticky();
  }

  /* ── bulk enquiry modal ── */
  var modal = root.querySelector('[data-vd-modal]');
  if (modal) {
    root.querySelectorAll('[data-vd-modal-open]').forEach(function (b) {
      b.addEventListener('click', function () { modal.hidden = false; });
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.closest('[data-vd-modal-close]')) modal.hidden = true;
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') modal.hidden = true;
    });
  }

  /* ── key features: clamp to ~8 lines, reveal the rest on See more ── */
  root.querySelectorAll('.vd-pdp__keys').forEach(function (keys) {
    var content = keys.querySelector('.vd-pdp__keys-html, .vd-pdp__keys-list');
    if (!content) return;
    var body = document.createElement('div');
    body.className = 'vd-pdp__keys-body';
    content.parentNode.insertBefore(body, content);
    body.appendChild(content);
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'vd-pdp__keys-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.innerHTML = '<span>See more</span><svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="m6 9 6 6 6-6"></path></svg>';
    body.parentNode.insertBefore(btn, body.nextSibling);
    var label = btn.querySelector('span');
    function sync() {
      if (btn.getAttribute('aria-expanded') === 'true') return;
      body.classList.add('is-clamped');
      var overflows = body.scrollHeight > body.clientHeight + 8;
      body.classList.toggle('is-clamped', overflows);
      btn.classList.toggle('is-on', overflows);
    }
    btn.addEventListener('click', function () {
      var open = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', open ? 'false' : 'true');
      body.classList.toggle('is-clamped', open);
      if (label) label.textContent = open ? 'See more' : 'See less';
    });
    sync();
    window.addEventListener('resize', function () { sync(); });
  });

  /* ── add to cart ──
     Adds through the Cart API, then sends the customer to the cart page. The toast alone
     left the tap looking ignored: nothing moved, so people tapped again. Buy Now still
     goes straight to checkout. Errors keep you on the page with the reason. */
  var toast = root.querySelector('[data-vd-toast]');
  var toastTimer;
  function flash(msg) {
    if (!toast) return;
    toast.textContent = msg;
    toast.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toast.classList.remove('is-on'); }, 2600);
  }

  root.querySelectorAll('form[data-vd-atc]').forEach(function (form) {
    form.addEventListener('submit', function (e) {
      var buyNow = e.submitter && e.submitter.hasAttribute('data-vd-buynow');
      e.preventDefault();

      var button = e.submitter;
      if (button) button.disabled = true;

      var body = new FormData(form);
      body.set('quantity', qty);

      fetch(shopRoot() + 'cart/add.js', { method: 'POST', body: body, headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          if (data && data.status && data.status !== 200) {
            if (button) button.disabled = false;
            flash(data.description || 'Could not add to cart');
            return;
          }

          if (buyNow) {
            window.location.href = shopRoot() + 'checkout';
            return;
          }

          document.querySelectorAll('[data-vd-cart-count]').forEach(function (el) {
            if (data.item_count != null) el.textContent = data.item_count;
            el.removeAttribute('hidden');
          });

          flash('\u2713 Added to cart \u2014 taking you to your cart…');
          window.location.href = shopRoot() + 'cart';
        })
        .catch(function () { form.submit(); });
    });
  });
})();
